// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__27q54","requiredAsterisk":"Info_requiredAsterisk__3hfH7"};